<template>
    <div class="ring_banner">
        <div class="ring_banner_upper radius_mod ">
            <h4 class="mb-0 font-active">Diamond Anniversary Rings</h4>
            <p class="mb-0">Explore our dazzling anniversary collection & pick the perfect ring to celebrate your special milestone.</p>
            <router-link :to="localePath({ name: 'shop-anniversary',  query:{'Style': 'Five-stone'}})" class="radious_four">SHOP NOW</router-link>
        </div>
        
        <picture>
            <source media="(min-width: 768px)" srcset="~/assets/home/two_x.webp" type="image/webp">
            <source media="(min-width: 768px)" srcset="~/assets/home/two_x.jpg" type="image/jpeg">

            <source media="(max-width: 767px)" srcset="~/assets/home/ring_banner_mobile.webp" type="image/webp">
            <source media="(max-width: 767px)" srcset="~/assets/home/ring_banner_mobile.jpg" type="image/jpeg">
   
            <img class="radious_eight" loading="lazy" alt="Diamond Anniversary Rings" width="4417" height="1146" src="~/assets/home/two_x.jpg" >
        </picture>
    </div>
    
</template>


<script setup>
    const localePath = useLocalePath()
</script>

<style scoped>
.ring_banner {
    position: relative;
    max-width: 1472px;
    margin: 0 auto;
}

.ring_banner_upper {
    position: absolute;
    top: 50%;
    left: 80%;
    transform: translate(-50%, -50%);
    width: 35%;
}

.ring_banner_upper h4 {
    color: #fff;
    font-size: 32px;
}

.ring_banner_upper p {
    font-size: 16px;
    color: #fff;
    padding: 4% 0 6% 0;
}

.ring_banner_upper a {
    border: 1px solid #fff;
    color: #fff;
    font-size: 14px;
    display: inline-block;
    padding: 6px 38px;
    font-weight: 700;
}

@media(max-width: 1024px){
    .ring_banner_upper {
        left: 77%;
        width: 41%;
    }
    .ring_banner_upper h4 {
        font-size: 24px;
    }
    .ring_banner_upper p {
        font-size: 14px;
    }
}
@media(max-width: 992px){
    .ring_banner_upper {
        position: relative;
        top: 0;
        left: 0;
        transform: none;
        width: 100%;
        background: #d09c97;
        text-align: center;
        padding: 8%;
        margin-bottom: -2px;
    }
    .ring_banner_upper p{
        padding: 2% 0 3% 0;
    }
    .radius_mod {
        border-radius: 8px 8px 0 0;
    }
    .radious_eight {
        border-radius: 0 0 8px 8px;
    }
   
}
@media(max-width: 767px){
   
    .ring_banner_upper p {
        font-size: 16px;
    }
}
</style>

